<script>
	import Module from '../components/Module.vue'

	export default {
		data: function(){
			return {
				name: 'ContactContainer'
			}
		},
			components:{
				Module
			}
	}
</script>

<template>
	<Module topColor="#F3F3F3" bottomColor="#16A085">
		<span slot="title" class="section_name" id="about_us_title">STAY IN TOUCH</span>
		<span slot="description" class="section_text" id="about_us_title">Be aware of the new improvements and the new products, suggest new features, let us know your thoughts or just say hi (or grrr...) on social networks!</span>
		<div class="section_action">
			<div slot="action">
				<a href="https://www.facebook.com/TossedCoindotcom"><font-awesome-icon :icon="['fab', 'facebook']" /></a>
				<a href="https://twitter.com/i_amandre"><font-awesome-icon :icon="['fab', 'twitter-square']" /></a>
			</div>
		</div>
		<div slot="action">
			<a href="https://www.facebook.com/TossedCoindotcom"><font-awesome-icon :icon="['fab', 'facebook']" /></a>
			<a href="https://twitter.com/i_amandre"><font-awesome-icon :icon="['fab', 'twitter-square']" /></a>
		</div>
	</Module>
</template>